/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'jquery';
import prestashop from 'prestashop';
import SlickSlider from "./components/slick";


$(document).ready(() => {
  prestashop.on('clickQuickView', function (elm) {
    let data = {
      'action': 'quickview',
      'id_product': elm.dataset.idProduct,
      'id_product_attribute': elm.dataset.idProductAttribute,
    };
    $.post(prestashop.urls.pages.product, data, null, 'json').then(function (resp) {
      $('body').append(resp.quickview_html);
      let productModal = $(`#quickview-modal-${resp.product.id}-${resp.product.id_product_attribute}`);
      productModal.modal('show');

      productModal.on('hidden.bs.modal', function () {
        productModal.remove();
      });
      productModal.on('shown.bs.modal', function () {
          productConfig(productModal);
      });
    }).fail((resp) => {
      prestashop.emit('handleError', {eventType: 'clickQuickView', resp: resp});
    });
  });

  var productConfig = (qv) => {
      let slickSlider = new SlickSlider();
      slickSlider.init();
    qv.find('#quantity_wanted').TouchSpin({
      buttondown_class: 'btn js-touchspin',
      buttonup_class: 'btn js-touchspin',
      min: 1,
      max: 1000000
    });
  };

  const parseSearchUrl = function (event) {
    if (event.target.dataset.searchUrl !== undefined) {
      return event.target.dataset.searchUrl;
    }

    if ($(event.target).parent()[0].dataset.searchUrl === undefined) {
      throw new Error('Can not parse search URL');
    }

    return $(event.target).parent()[0].dataset.searchUrl;
  };

  $('body').on('change', '#search_filters input[data-search-url]', function (event) {
    prestashop.emit('updateFacets', parseSearchUrl(event));
  });

  $('body').on('click', '.js-search-filters-clear-all', function (event) {
    prestashop.emit('updateFacets', parseSearchUrl(event));
  });

  $('body').on('click', '.js-search-link', function (event) {
    event.preventDefault();
    prestashop.emit('updateFacets', $(event.target).closest('a').get(0).href);
  });

  $('body').on('change','#select-sort-order', function () {
      var urlsearch = $(this).val();
      prestashop.emit('updateFacets',urlsearch);
  });

  $('body').on('change', '#search_filters select', function (event) {
      var urlsearch = $(this).val();
    prestashop.emit('updateFacets', urlsearch);
  });

  prestashop.on('updateProductList', (data) => {
    updateProductListDOM(data);
    window.scrollTo(0, 0);
  });
  
  
 /*29/06/2022: afficher guide oreiller seulement sur certaines pages dans la colonne de droite */
  $("#right-column .configurateur_hide").removeClass("configurateur_visible");
    if($("#right-column .configurateur_hide").length>0){
	    var class_css = $("#right-column .configurateur_hide").attr('class').split(' ');	
	    for (var item in class_css) {
	   		if(class_css[item].indexOf("categ-visible")!==-1){
	   				var pages = class_css[item].split('_');
	   				 for (var i in pages) {
	   				 	if($.isNumeric(pages[i])){
	   						$(".category-id-"+pages[i]+" .configurateur_hide").addClass("configurateur_visible");
	   					}
	   				}
	   		}
	   		else if(class_css[item].indexOf("as-visible")!==-1){
	   				var pages = class_css[item].split('_');
	   				 for (var i in pages) {
	   				 	console.log(pages[i]);
	   				 	if($.isNumeric(pages[i])){
	   						$("#advancedsearch-seo-"+pages[i]+" .configurateur_hide").addClass("configurateur_visible");
	   					}
	   				}
	   		}
	   		
		}
	}
});

function updateProductListDOM (data) {
  $('#search_filters').replaceWith(data.rendered_facets);
  $('#js-active-search-filters').replaceWith(data.rendered_active_filters);
  $('#js-product-list-top').replaceWith(data.rendered_products_top);
  $('#js-product-list').replaceWith(data.rendered_products);
  $('#js-product-list-bottom').replaceWith(data.rendered_products_bottom);
  if (typeof(data.rendered_products_header) !== 'undefined' && data.rendered_products_header) {
      $('#js-product-list-header').replaceWith(data.rendered_products_header);
  }

}
